import React from 'react';
// import { Link } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { faHandHoldingHeart} from '@fortawesome/pro-light-svg-icons';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { faList } from '@fortawesome/pro-light-svg-icons';
import { faSmile } from '@fortawesome/pro-light-svg-icons';
import { TextButton } from './buttons/TextButton';

// Home Page Section 3 / How it works
export const HomePageS3  = (props) =>  ( 
    <div className="homepage-s3">
        <h3 className="homepage-s3__heading"><a id="how-it-works">How It Works</a></h3>
        {/* <h3 className="homepage-s3__heading">How it Works</h3> */}
        <div className="process-box-container">
           <div className="process-box">
               <FontAwesomeIcon className="process-box__icon" icon={faCalendarAlt} />
               <p className="process-box__heading">Schedule Event</p>
               <p className="process-box__text">Quickly Schedule an Event</p>
           </div>
           <div className="process-box">
               <FontAwesomeIcon className="process-box__icon" icon={faUsers} />
               <p className="process-box__heading">Add People</p>
               <p className="process-box__text">Add People To Your Event or Function</p>
           </div>
           <div className="process-box">
               <FontAwesomeIcon className="process-box__icon" icon={faList} />
               <p className="process-box__heading">List Items</p>
               <p className="process-box__text">Create List of Contributions and/or Help Needed</p>
           </div>
           <div className="process-box">
               <FontAwesomeIcon className="process-box__icon fal" icon={faHandHoldingHeart} />
               <p className="process-box__heading">Pitch In</p>
               <p className="process-box__text">Invite People to Pitch In</p>
           </div>
           <div className="process-box">
                <FontAwesomeIcon className="process-box__icon fal" icon={faSmile} />
               <p className="process-box__heading">Enjoy</p>
               <p className="process-box__text">Enjoy the Fruits of your Labor!</p>
           </div>
        </div>
        <h3 className="cta-text-s3">Sign Up for the "Pitch In" Club Today</h3>
        <Link to="/signup#header-section" className="signup-button-s3"><p>Sign Up Free</p></Link>
        <div className='signup-button-mb'>&nbsp;</div>
        <div className="show-for-mobile">
            <Link smooth to="/#cta" className="small-text-link" >Back</Link>
        </div>
    </div>
);


// export class HomePageS3 extends React.Component  {
//     // Allows user to get rid of message box by hitting Ok button.
//     handleSignup = () => {
//         history.push('/signup');    
//     };

//     render()  {
//         return  ( 
//         <div className="homepage-s3">
//             <h3 className="homepage-s3__heading">How it Works</h3>
//             <div className="process-boxes">
//             <div className="process-box">
//                 <FontAwesomeIcon className="process-box__icon" icon={faCalendarAlt} />
//                 <p className="process-box__heading">Schedule Event</p>
//                 <p className="process-box__text">Quickly Schedule an Event or Function</p>
//             </div>
//             <div className="process-box">
//                 <FontAwesomeIcon className="process-box__icon" icon={faList} />
//                 <p className="process-box__heading">List Items</p>
//                 <p className="process-box__text">Create List of Contributions and/or Help needed</p>
//             </div>
//             <div className="process-box">
//                 <FontAwesomeIcon className="process-box__icon" icon={faUsers} />
//                 <p className="process-box__heading">Add Members</p>
//                 <p className="process-box__text">Add club members and send notification</p>
//             </div>
//             <div className="process-box">
//                 <FontAwesomeIcon className="process-box__icon fal" icon={faHandHoldingHeart} />
//                 <p className="process-box__heading">Pitch In</p>
//                 <p className="process-box__text">Members "Pitch In" to help</p>
//             </div>
//             <div className="process-box">
//                     <FontAwesomeIcon className="process-box__icon fal" icon={faSmile} />
//                 <p className="process-box__heading">Enjoy</p>
//                 <p className="process-box__text">Kick back and Enjoy!</p>
//             </div>
//             </div>
//             <h3>Sign Up for the "Pitch In" Club Today</h3>
//             <button type="button" className="button-shadow button--oval" 
//                           onClick={this.handleSignup} >
//                     Sign Up Free
//             </button> 
//        </div>
//        );
//     }
// }






// WEBPACK FOOTER //
// ./src/components/HomePageS3.js